import {
  Component,
  Input,
  inject,
  TemplateRef,
  ViewEncapsulation,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { Overlay } from '@angular/cdk/overlay';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/shareModule/services/common.service';
import {
  Chart,
  CategoryScale,
  LinearScale,
  BarController,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartType,
  PointElement,
  ScatterController,
} from 'chart.js';
import { ImageModalComponent } from 'src/app/shareModule/component/chat/chatbot/image-modal.component';
import { PopUpService } from 'src/app/popupservice.service';
import { GoogleMapsService } from 'src/app/google-maps.service';

@Component({
  selector: 'app-votes-section',
  templateUrl: './votes-section.component.html',
  styleUrl: './votes-section.component.scss',
})
export class VotesSectionComponent implements OnInit {
  
  @Output()
  public viewProduct = new EventEmitter()

  constructor(
    private modalService: NgbModal,
    private sharedService: SharedService,
    private bottomSheet: MatBottomSheet,
    private overlay: Overlay,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef,
    private popup: PopUpService,
    private googleMapsService: GoogleMapsService
  ) {}
  public votes = [];

  public categories = [];
  public selectedCategoryId = null;

  public fetchByCategory(cat) {
    if (this.selectedCategoryId == cat.id) {
      this.selectedCategoryId = null;
    } else {
      this.selectedCategoryId = cat.id;
    }
    this._fetchPopularList();
  }

  public showImage(url, { otherImages = [], cropInformation = [] }) {

    let ref = this.popup.openPopup(ImageModalComponent, {
      bottomSheetPanelClass: 'bottom-sheet-1',
      modalSize: 'sm',
      modalWindowClass: 'image-modal',
      noHistory: true,
      hasBackdrop: true
    })
    let instance;
    if (this.isMobile) {
      ref = ref as MatBottomSheetRef;
      instance = ref.instance
      

    } else {
      ref = ref as NgbModalRef
      instance = ref.componentInstance;

    }
    instance.otherImages = otherImages.filter(img => !!img).map(img => environment.ImageUrl + img)
    instance.imageSrc = environment.ImageUrl + url;
    instance.cropInformation = cropInformation


  }
  private _categoriesProducts(products) {
    this.votes = [];

    console.log('votes products', products);
    const map = new Map();
    const categoryIdNameMap = new Map();
    for (const prod of products) {
      if (!map.has(prod.categoryName)) {
        map.set(prod.categoryName, []);
      }
      // if (map.get(prod.categoryName).length < 5) {
        
      // }
      map.get(prod.categoryName).push(prod);
      categoryIdNameMap.set(prod.categoryName, prod.categoryId);
    }
    console.log('map votes=', map);
    for (const key of map.keys()) {
      this.votes.push({
        categoryName: key,
        categoryId: categoryIdNameMap.get(key),
        pollId: map.get(key)?.at(0)?.pollId,
        industryStandard: map.get(key)?.at(0)?.industryStandard,
        products: map.get(key),
      });
    }
    this.votes.sort((a: any, b: any) => b.products.length - a.products.length);
    this.votes.forEach(vote => this._sortProductsByVote(vote.products ?? []))
    this.cdr.markForCheck();
    console.log('votes', this.votes);
  }

  private _sortProductsByVote(products){
    products.sort((a,b) => a.votesCount - b.votesCount)
  }
  @ViewChild('myChart')
  public myChart: ElementRef;

  public currentCounts = [];
  public currentIndustryStandard = '';
  public openProduct(prod){
    this.viewProduct.next(prod)
  }
  private _setupChart() {
    Chart.register(
      ScatterController,
      PointElement,
      LinearScale,
      Tooltip,
      Legend,
    );

    // ------------ USER DATA (replace with your array) -------------
    const items = this.compData;
    const pointImages = this.compData
      .filter((c) => c.image)
      .map((c) => {
        const img = new Image();
        //img.style.width = '25px';
        // img.style.height = '25px'
        img.height = 20;
        img.width = 20;
        //  img.style.borderRadius='50%'
        img.src = c.image;
        return img;
      });
    // [
    //   { label: 'Type A', value: -1 },
    //   { label: 'Type B', value: 2 },
    //  // { label: 'Type C (middle)', value: 0 }, // <-- middle index expected to show customZeroText
    //   { label: 'Type D', value: 3 },
    //   { label: 'Type E', value: -4 }
    // ];
    const customZeroText = ''; // <--- text to show inside middle circle when its value === 0

    // ------------- layout / duplicates jitter -------------
    const n = items.length;
    const rowSpacing = 20;
    const canvasHeight = Math.max(80, n * rowSpacing + 40);
    const canvas = this.myChart.nativeElement;
    canvas.height = canvasHeight;

    const baseYs = items.map((_, i) => i * rowSpacing + 30);

    const groups = new Map();
    items.forEach((it, idx) => {
      const key = String(it.value);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(idx);
    });

    const jitterStep = 20;
    const jitterByIndex = new Array(n).fill(0);
    groups.forEach((indices) => {
      if (indices.length === 1) {
        jitterByIndex[indices[0]] = 0;
        return;
      }
      const k = indices.length;
      const half = (k - 1) / 2;
      indices.sort((a, b) => a - b);
      for (let j = 0; j < k; j++)
        jitterByIndex[indices[j]] = (j - half) * jitterStep;
    });

    items.sort((a, b)=> a.value - b.value)
    console.log('points=', items.map(item => item.value))
   
    let lastValue = -100000;
    const DIST = 1;
    for(const item of items){
      if(item.value - DIST <= lastValue){
        item.value += DIST;
      }
      lastValue = item.value;
    
    }
    const points = items.map((it, i) => 
      {
        if(it.valueY){
          console.log({it},'hasAfforableScors')
        }
        return({  
          x: it.value,
          y: canvasHeight * 0.5 + (it.valueY ?? 0) * 5
        })
      }
      
    );
    const texts = new Set();

    const colors = ['#60a5fa', '#34d399', '#f472b6', '#f59e0b', '#a78bfa'];
    const bgColors = items.map((_, i) => colors[i % colors.length]);

    const imagePointPlugin = {
      id: 'imagePoint',
      afterDatasetsDraw(chart) {
        const ctx = chart.ctx;
        const meta = chart.getDatasetMeta(0); // first dataset
        meta.data.forEach((point, i) => {
          const img = pointImages[i];
          if (!img) return;

          const size = 40; // image size
          const radius = size / 2;

          ctx.save();

          // 🌟 set shadow before drawing
          ctx.shadowColor = 'rgba(0, 0, 0, 0.4)'; // shadow color
          ctx.shadowBlur = 8; // softness
          ctx.shadowOffsetX = 3; // x offset
          ctx.shadowOffsetY = 3; // y offset

          // ✂️ create circular clipping pathpointImages
          ctx.beginPath();
          ctx.arc(point.x, point.y, radius, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.clip();

          // 🖼️ draw image inside clipped circle
          ctx.drawImage(img, point.x - radius, point.y - radius, size, size);
          

          ctx.restore();

          ctx.font = '12px Arial';
          ctx.fillStyle = 'gray';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';

           const drawWrappedText = (ctx, text, x, y, maxWidth, lineHeight) => {
              if(texts.has(x)){
                return;
              }
              texts.add(x)
              const words = text.split(' ');
              let line = '';
              let lines = [];

              for (let n = 0; n < words.length; n++) {
                  const testLine = line + words[n] + ' ';
                  const metrics = ctx.measureText(testLine);
                  const testWidth = metrics.width;

                  if (testWidth > maxWidth && n > 0) {
                      lines.push(line.trim());
                      line = words[n] + ' ';
                  } else {
                      line = testLine;
                  }
              }
              lines.push(line.trim());

              for (let i = 0; i < lines.length; i++) {
                  ctx.fillText(lines[i], x, y + i * lineHeight);
              }
          }

       
          // ctx.fillText(items[i].label, point.x, point.y - 50);
          drawWrappedText(ctx, items[i].label, point.x,  point.y - 50, 80, 10);

          ctx.restore(); // Restore state

          // (Optional) add a nice white border ring
          ctx.save();
          ctx.beginPath();
          ctx.arc(point.x, point.y, radius, 0, Math.PI * 2, true);
          ctx.lineWidth = 3;
          ctx.strokeStyle = '#b32596';
          ctx.stroke();
          ctx.restore();
        });
      },
    };

    // ------------- Plugin draws labels INSIDE circles -------------
    const insideLabelPlugin = {
      id: 'insideLabelPlugin',
      afterDatasetsDraw(chart) {
        const { ctx } = chart;
        const meta = chart.getDatasetMeta(0);
        if (!meta || !meta.data) return;

        const midIndex = Math.floor(items.length / 2); // middle index (works for odd/even lengths)

        ctx.save();

        meta.data.forEach((elem, i) => {
          const px = elem.x;
          const py = elem.y;

          // Decide text: if this is the middle index and value === 0 -> show customZeroText
          const rawValue = '';
          let text;
          const isMiddle = i === midIndex;
          if (isMiddle && Number(rawValue) === 0) {
            text = String(customZeroText);
          } else {
            // show numeric value inside circle
            text = String(rawValue);
          }

          // Choose font size and weight: middle text more prominent
          let fontSize = 12;
          let fontWeight = 'normal';
          if (isMiddle && Number(rawValue) === 0) {
            fontSize = 13;
            fontWeight = '600';
          }
          if (text.length > 4) fontSize = Math.max(9, fontSize - 2);

          ctx.font = `${fontWeight} ${fontSize}px system-ui, Arial`;
          ctx.textBaseline = 'middle';
          ctx.textAlign = 'center';

          // Contrast color calculation
          function luminance(hexOrRgb) {
            if (!hexOrRgb) return 0.2;
            if (hexOrRgb.startsWith('rgb')) {
              const nums = hexOrRgb
                .replace(/[^\d,]/g, '')
                .split(',')
                .map(Number);
              const [r, g, b] = nums;
              return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
            }
            const hex = hexOrRgb.replace('#', '');
            const full =
              hex.length === 3
                ? hex
                    .split('')
                    .map((h) => h + h)
                    .join('')
                : hex;
            const n = parseInt(full, 16);
            const r = (n >> 16) & 255,
              g = (n >> 8) & 255,
              b = n & 255;
            return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
          }

          const bg = bgColors[i] || '#60a5fa';
          const lum = luminance(bg);
          ctx.fillStyle = lum > 0.6 ? '#111' : '#fff';

          // Finally draw the text
          ctx.fillText(text, px, py);
        });

        ctx.restore();
      },
    };
    Chart.register(insideLabelPlugin);
    Chart.register(imagePointPlugin);
    const zeroLinePlugin = {
      id: 'zeroLine',
      currentIndustryStandard: this.currentIndustryStandard,
      afterDraw(chart, args, options) {
        const ctx = chart.ctx;
        const chartArea = chart.chartArea;
        if (!chartArea) return;

        // find the y scale (usually named 'y')
        const yScale = chart.scales && (chart.scales.y || chart.scales['y']);
        if (!yScale || typeof yScale.getPixelForValue !== 'function') return;

        // compute pixel for value 0
        const yPixel = yScale.getPixelForValue(0);

        // only draw if 0 is inside (or slightly outside) the visible plotting area
        if (yPixel < chartArea.top - 4 || yPixel > chartArea.bottom + 4) return;

        // options with defaults
        const {
          color = 'gray',
          width = 1,
          dash = [2, 5],
          label = {
            text: this.currentIndustryStandard,
            font: '18px system-ui',
            color: null,
            offset: 0,
            align: 'center',
          },
        } = options || {};

        ctx.save();

        // draw horizontal line
        ctx.beginPath();
       // ctx.setLineDash(Array.isArray(dash) && dash.length ? dash : []);
        ctx.lineWidth = width;
        ctx.strokeStyle = color;
        //const py = Math.round(yPixel) + 0.5; // crisp 1px alignment
        ctx.moveTo(chartArea.right * 0.2,  0.88 * canvasHeight); // start right * 0.4
        ctx.lineTo(chartArea.right, 0.88 * canvasHeight); // end right
        ctx.stroke();
        ctx.closePath();

        

        // const py = Math.round(yPixel) + 0.5; // crisp 1px alignment
        ctx.moveTo(chartArea.right * 0.2  , canvasHeight * .88); // start left
        ctx.lineTo(chartArea.right * 0.2 , 0); // end right
        ctx.stroke();
        ctx.closePath();


        ctx.beginPath();
        ctx.setLineDash(Array.isArray(dash) && dash.length ? dash : []);
        ctx.lineWidth = width;
        ctx.strokeStyle = color;
        // const py = Math.round(yPixel) + 0.5; // crisp 1px alignment
        ctx.moveTo(chartArea.right * 0.2 , canvasHeight * 0.88); // start right * 0.4
        ctx.lineTo(chartArea.right , 0); // end right
        ctx.stroke();
        ctx.closePath();


        // draw label on the left of the chart
        if (label && label.text) {
          ctx.font = label.font || '12px system-ui';
          ctx.textAlign = label.align || 'center';
          ctx.fillStyle = label.color || color;
          ctx.textBaseline = 'bottom';
          const labelX = chartArea.right * 0.5;
          const labelY = canvasHeight ;
          ctx.fillText(String(label.text), labelX, labelY);
        }

        ctx.setLineDash([]);
        ctx.restore();
      },
    };

    // Usage example (assumes Chart is available, Chart.js v4+):
    // Register the plugin and create a chart that uses a linear x scale.
    Chart.register(zeroLinePlugin);

    // ------------- Build scatter chart (circles only) -------------
    console.log({ pointImages });

    const chart = new Chart(canvas.getContext('2d'), {
      type: 'scatter',
      data: {
        datasets: [
          {
            label: 'circles',
            data: points,
            pointStyle: pointImages,
            pointRadius: 10, // controls circle size
            pointHoverRadius: 12,
            backgroundColor: bgColors,
            borderColor: '#ffffff',
            borderWidth: 1.5,
            showLine: false,
          },
        ],
      },

      options: {
        interaction: {},
        events: [],
        //  events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'linear',
            display: false,
            // give little padding left/right so circles aren't flush with edges:
            min: Math.min(...items.map((i) => i.value)) - 6,
            max: Math.max(...items.map((i) => i.value)) + 6,
          },
          y: {
            type: 'linear',
            display: false,
            min: -10,
            max: baseYs[n - 1] + 50,
          },
        },
      },
    });

    // If you still don't see the midd

    this.cdr.markForCheck();
  }

  public userComments = [];
  public userCommentsTotal = [];
  @ViewChild('comments') commentsTemplate: TemplateRef<any>;

  public user = null;
  public compData = [];
  private _processComparisons() {
    //this.currentIndustryStandard = 'hello'
    this.compData = [];
    console.log('userComments', this.userCommentsTotal);
    const comparableAns = this.userCommentsTotal.filter(
      (comment) => comment.comparableAns,
    );
    const pollRatings = new Map();
    console.log({ comparableAns });
    for (const ans of comparableAns) {
      if (!pollRatings.has(ans.pollId)) {
        pollRatings.set(ans.pollId, 0);
      }
      let pollRating = pollRatings.get(ans.pollId);
      if (ans.comparableAns == 'Yes') {
        pollRating++;
      } else if (ans.comparableAns == 'No') {
        pollRating--;
      } else {
        continue;
      }
      pollRatings.set(ans.pollId, pollRating);
    }
    console.log({ pollRatings });
    this.compData = this.votes
      .map((v) => v.products)
      .flat(2)
      // .filter(prod => prod.pollId = this.selectedSubpollId)
      .map((prod) => {
        return {
          valueY: prod.affordableScore,
          value: pollRatings.get(prod.pollId),
          label: prod.name,
          pollId: prod.pollId,
          image: this.imgUrl + prod.indexImage,
        };
      })
      .filter((rating) => rating.value != undefined); //no unrated ones
    console.log('compData', this.compData);

    setTimeout(() => this._setupChart(), 1000);
    this.cdr.markForCheck();
  }
  public anyChildHasPoll(cat){
    const rv = cat?.subCategory?.some(subCat => subCat.hasPoll);
   // console.log({cat}, {rv})
    cat.hasPoll = rv;
    return rv; 
  }
  public selectedSubCategoryId = null;
  public currentVoteCat = null;
  public openComments(voteCat) {
    this.currentVoteCat = voteCat;
    this.modalRef = this.modalService.open(this.commentsTemplate, {
      size: 'lg',
    });
    // this.userComments = [{
    //   userName: 'Ebenezer',
    //   text: 'Very tired but will keep on'
    // }]
    ///  this.selectedSubCategoryId = voteCat.categoryId
    console.log({ voteCat });
    this.auth.getOpenEndedAnswersForPoll(voteCat.pollId).subscribe({
      next: (data) => {
        this.userCommentsTotal = data.body;
        this.userComments = this.userCommentsTotal.filter(
          (a) => a?.answer && a.categoryId == voteCat.categoryId,
        );
        this._processComparisons();
        this.currentIndustryStandard = voteCat.industryStandard;
        this.cdr.detectChanges();
      },
      error: console.error,
    });
  }
  public openPollOn(voteCat) {
    this.auth
      .poll_fetch({
        isAll: false,
        productId: null,
        fetchCategoryOnly: false,
        categoryId: voteCat.categoryId,
        subRegionId: this.local.getUser()?.region,
      })
      .subscribe({
        next: (data: any) => {
          console.log('poll data', data);
          this.sharedService.openNewUserSurveySubject.next({
            page: 3,
            poll: data.body.data[0],
          });

          this.cdr.detectChanges();
        },
        error: console.error,
      });
  }

  public map
  public selectedVoteCatForMap = null
  public openMapOn(template, voteCat){
    this.selectedVoteCatForMap = voteCat
    this.modalRef =  this.modalService.open(template, {size: 'lg'});
    setTimeout(()=>{
      this.map = this.googleMapsService.createMap('map_1', {zoom: 13});
      this.googleMapsService.initProductMap(this.map, 'map_1')
      this.googleMapsService.addProductDataToMap(voteCat.products, 'products')
    })

  }
  private _fetchPopularList() {
    this.auth
      .getPopularProductsBasedOnPoll({
        categoryId: this.selectedCategoryId,
        subRegionId: this.subRegionId,
      })
      .subscribe({
        next: (data) => {
          this._categoriesProducts(data.body);
        },
        error: console.error,
      });
  }
  ngOnInit(): void {
    this.commonService.categoryList.subscribe((data) => {
      this.categories = structuredClone(data);
    });
    const user = this.local.getUser();
    if (user) {
      this.subRegionId = user.region;
      this._fetchPopularList();
    }
    this.local.getUserDetailsObserver().
    subscribe(
      user =>{
        this.user = user;
        this.cdr.markForCheck()
      }
    )
  }
  @Input() subRegionName: string = '';
  public onImgError(error) {
    (event.target as HTMLImageElement).style.backgroundImage =
      `url('../../../../../../assets/images/shop/default.png')`;
  }

  public imgUrl = environment.ImageUrl;

  public pollCheck(event, voteCat, prod){


    if(!this.user){
      return;
    }
    const payload = {
      userId: this.user.id,
      pollDetailId: prod?.pollDetailId,
      addTagWithSameNameWhenOptionClicked: false,
      isAdmin: 0
    // pollName: prod?.name

    };
    this.auth.poll_check(payload).subscribe({
      next: () =>{
        if(prod.haveIVoted){
          prod.votesCount  -= 1
        }else{
          prod.votesCount  += 1
        }
        
        this._sortProductsByVote(voteCat.products);
        this.cdr.markForCheck()
      },
      error: console.error
    })

  }
  public subRegionId = null;
  carouselOptions: any = {
    slidesPerView: 1,
    spaceBetween: 25,
    pagination: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  };
  modalRef: MatBottomSheetRef<any> | any = null;
  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth < 767;
  }
  public closeModalByRef() {
    this.modalRef?.dismiss();
  }
  openVerticallyCentered(content: TemplateRef<any>) {
    if (this.isMobile) {
      this.modalRef = this.bottomSheet.open(content, {
        scrollStrategy: this.overlay.scrollStrategies.block(),
        panelClass: 'bottom-sheet-1',
      });
    } else {
      this.modalRef = this.modalService.open(content, {
        centered: true,
        size: 'xl',
        windowClass: 'votes-popup my-modal',
      });

      this.modalRef.result
        .then((result) => {
          console.log('Modal closed with:', result);
          this.modalRef = null;
        })
        .catch((reason) => {
          console.log('Modal dismissed with:', reason);
          this.modalRef = null;
        });
    }
  }
}
